export default __webpack_public_path__ + "static/media/hawaiian-peeksa.3f348549.jpg";